import {PaymentCardReaderSummaryModel} from "../paymentCardReaderSummary.model";
import {Injectable} from '@angular/core';
import {HttpModelConverter} from "../../../../../../../core/converter/httpModel.converter";
import {PermissionsConverter} from "../../../../../../../common/converter/permissions.converter";
@Injectable({
    providedIn: 'root'
})
export class PaymentCardReaderSummaryConverter extends HttpModelConverter<PaymentCardReaderSummaryModel> {

    constructor(private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): PaymentCardReaderSummaryModel {
        return new PaymentCardReaderSummaryModel();
    }

    protected enrichObject(result: PaymentCardReaderSummaryModel, src: PaymentCardReaderSummaryModel) {
        result.permissions = this.permissionConverter.convert(src.permissions);
    }
}
